import { z } from 'zod';
import { bindInputMaker } from '../util.make-input.js';

const makeInput = bindInputMaker();
const selectableWordInput = makeInput({
  entry: {
    schema: z.object({
      type: z.literal("selectable-word").default("selectable-word"),
      selected: z.boolean().default(false)
    }),
    shouldValidate: (node, entry) => node.validation.shouldBeMarked || !!entry?.selected,
    validate: (node, entry) => node.validation.shouldBeMarked === entry.selected,
    parseLegacyDetailItem: (item, context) => {
      if (["SelectAnswers"].includes(context.relatedTask.taskType) && ["MarkWords"].includes(context.relatedTask.answerType ?? "") && typeof item === "boolean") {
        return [context.relatedInput?.id ?? `${context.relatedTask.id}-${context.indexInDetails}`, {
          type: "selectable-word",
          selected: item
        }];
      }
    }
  },
  schema: z.object({
    type: z.literal("Word"),
    text: z.string(),
    correctAnswer: z.boolean().default(false)
  }),
  postprocessSchemaInput: ({
    correctAnswer,
    ...input
  }, context) => {
    return {
      ...input,
      id: `${context.taskId}-${context.index}`,
      nodeType: "selectable-word-input",
      validation: {
        shouldBeMarked: correctAnswer
      }
    };
  }
});

export { selectableWordInput };
//# sourceMappingURL=input.selectable-word.js.map
